import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from '@material-ui/core';
import IconEdit from '@material-ui/icons/Edit';

import { APPROVAL_TYPE } from 'src/data/brandTerm';
import { DetailsItem } from '../DetailsItem';
import { useStyles } from './useStyles';

export const RuleDetails = ({ className, brandTerm, onEditClick, disabled }) => {
  const styles = useStyles();

  const { approvalType, description, approvedUseExamples, misuseExamples } = brandTerm;
  const shouldDisplayApprovedExamples =
    approvalType === APPROVAL_TYPE.approved && approvedUseExamples?.length > 0;
  const shouldDisplayMisusedExamples = misuseExamples?.length > 0;
  const hasContentToDisplay =
    description || shouldDisplayApprovedExamples || shouldDisplayMisusedExamples;

  const handleEditClick = () => {
    onEditClick(brandTerm);
  };

  return (
    <div className={cx(styles.root, className)}>
      {hasContentToDisplay && (
        <div className={styles.content}>
          {description && (
            <DetailsItem
              className={styles.detailsItem}
              title="Description"
              text={description}
            />
          )}

          {shouldDisplayApprovedExamples && (
            <DetailsItem
              className={styles.detailsItem}
              title="Approved use Examples"
              examples={approvedUseExamples}
            />
          )}

          {shouldDisplayMisusedExamples && (
            <DetailsItem
              className={styles.detailsItem}
              title="Misuse Examples"
              examples={misuseExamples}
            />
          )}
        </div>
      )}

      <div className={styles.footer}>
        <Button
          className={styles.buttonEdit}
          onClick={handleEditClick}
          startIcon={<IconEdit />}
          disabled={disabled}
          variant="contained"
          color="primary"
          size="small"
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

RuleDetails.propTypes = {
  className: PropTypes.string,
  brandTerm: PropTypes.shape().isRequired,
  onEditClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RuleDetails.defaultProps = {
  className: '',
  disabled: false,
};
